import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { SecondsToTimestampPipe } from '../../../../../@common/pipe/seconds-to-timestamp.pipe';

export interface SlideItem {
    id: number;
    title: string;
    image: string;
    timestamp: number;
}

@Component({
    selector: 'app-slide-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SecondsToTimestampPipe
    ],
    styles: `
        @use "variables" as *;

        .slide-item {
            padding: 0.75rem 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 1rem;

            &:hover {
                background-color: $form-outline;
            }
        }

        .slide-title {
            color: $grey-dark;
            padding-right: 1rem;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .slide-time {
            color: $grey-dark;
            font-weight: 600;
        }
    `,
    template: `
        <div class="slide-item" [title]="slide()?.title">
            <span class="slide-title" (click)="onSelect.emit()">{{ slide()?.title || 'Untitled' }}</span>
            <span class="slide-time">{{ slide()?.timestamp | secondsToTimestamp }}</span>
        </div>
    `
})
export class SlideItemComponent {
    public slide = input<SlideItem>();
    @Output() onSelect = new EventEmitter();
}
